import { Card } from "@/components/ui/card";
import { parseCustomFields, visibleCustomFields } from "@produce/shared";

/**
 * Renders the producer-defined extra briefing fields as an "Additional
 * information" card. Shared by the review/publish and portal briefing
 * pages. Returns null when there are no non-empty fields, so callers can
 * drop it in unconditionally.
 */
export function CustomFieldsCard({ customFields }: { customFields: unknown }) {
  const fields = visibleCustomFields(parseCustomFields(customFields));
  if (fields.length === 0) return null;
  return (
    <Card className="mb-6 bg-card p-8">
      <h2 className="mb-6 text-2xl font-bold">Additional information</h2>
      <div className="space-y-6">
        {fields.map((f) => (
          <div key={f.id}>
            <h3 className="mb-2 text-sm font-semibold text-muted-foreground">
              {f.title || "Untitled"}
            </h3>
            <p className="whitespace-pre-wrap text-foreground">{f.content}</p>
          </div>
        ))}
      </div>
    </Card>
  );
}
